<template>
  <!-- BEGIN Page Footer -->
  <div>
  <div class="foot" >
          <div class="r-info">
            <div class="wx-img">
              <img src="/static/qrcode_04_20.jpg" />
            </div>
            <div class="moble">
              <div class="title">联系我们</div>
              <div class="user">联系人：李经理</div>
              <div class="user">联系电话：18652557795</div>

            </div>
            <div class="number">北京制汇互联信息技术有限公司是依托于北京航空航天大学大数据科学中心的国家高新技术企业。 公司推出的“展小帮”展会小程序，已经服务了3000多场线下展会，覆盖航空航天、机械、汽车、电子等多个行业，为主办方提供展会服务一站式解决方案，是主办方展会小程序的首要之选</div>

          </div>
  </div>
  <a href="https://beian.miit.gov.cn" target="_blank" class="bootom">
    北京制汇互联信息技术有限公司  ICP证：京ICP备17000162号-13
  </a>
</div>
  <!-- END Page Footer -->
</template>

<script>
import appsettings from "../utils/appsettings";
export default {
  props: [],
  data() {
    return {
      appsettings: appsettings,
    };
  },
  mounted() {
   
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
.foot {
  width: 100%;
  background-image: linear-gradient(90deg, #2D76E4 0%, #004CBF 100%);
    height: 227px;
  .r-info {
    width: 100%;
    height: 100%;
    display: flex;
    max-width: 1424px;
    margin: 0px auto;
    align-items: center;
    align-content: center;
    .wx-img {
      margin-right: 57px;

      img {
        width: 97px;
        height: 97px;
      }
    }

    .number {
      width: 910px;
      font-family: SourceHanSansCN-Medium;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 30px;
    }

    .moble {
      width: 360px;

      .title {
        font-family: SourceHanSansCN-Bold;
        font-weight: 700;
        font-size: 26px;
        color: #FFFFFF;
      }

      .user {
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
      }
    }

  }

  .icp {
    display: block;
    clear: both;
    font-size: 0.9em;
    color: #fff;
    margin: 0 auto;
    width: 16em;
    text-align: center;
    border-bottom: none;
  }
}
.bootom{
  display: block;
  border-bottom:none;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
font-weight: 500;
font-size: 16px;
color: #898989;
line-height: 62px;
background-image: linear-gradient(180deg, #EEEEEE 0%, #EEEEEE 100%);
}
</style>



// WEBPACK FOOTER //
// src/components/viewFooter.vue